import request from './request';

export const apiPostInvitation: (data: {
  code: string;
  tg_channel_id?: string;
  x_url?: string;
}) => Promise<{
  message: string;
}> = (data) => {
  return request.post(`/referral/api/v1/tg/invitation`, data);
};

export const apiGetUserInformation: () => Promise<{
  code: string;
  photo_url: string;
  user_name: string;
}> = () => {
  return request.get(`/referral/api/v1/tg/user/information`);
};

export const apiGetInvitationList: (query: { cursor: number }) => Promise<{
  has_next: boolean;
  list: InvitedUserItemType[];
  next_cursor: number;
}> = (query) => {
  return request.get(`/referral/api/v1/tg/invitation/list`, {
    params: {
      ...query,
      pageSize: 50,
    },
  });
};

export const apiGetInvitationInvitees: () => Promise<{
  total_invitees: number;
}> = () => {
  return request.get('/referral/api/v1/tg/invitation/invitees');
};
